/**
 * Created by laszlo.czondor on 2017. 11. 13.
 */
import Multiselect from 'vue-multiselect';
import VueScrollTo from 'vue-scrollto';
import searchBox from '../../common/search-box/search-box';
import Pagination from '../../common/pagination/pagination.vue'
import {mapActions} from 'vuex';
import {PREFIX, SEARCH_URL, SUGGEST_URL} from '../../common/utils/api';

const QUERY_HASH = '#query=';
const PAGE_SIZE = 10;
const MIN_QUERY_LENGTH = 3;

export default {
	components: {
		'multiselect': Multiselect,
		'search-box': searchBox,
		'pagination': Pagination
	},
	data() {
		return {
			suggestions: [],
			suggestion: '',
			searchResults: [],
			pages: [],
			currentPage: 0,
			numberOfPages: 1,
			numberOfSearchResults: 0,
			query: '',
			isLoading: true,
			searchedAtLeastOnce: false,
			hitsOnPage: 10, //default érték, de egyébként a keresés response-ból jön, hogy mennyi találtat van egy oldalon
			searchInAttachments: false,
			labels: window.searchHitsLabels || {}
		};
	},
	methods: {
		createFullUrl(searchResultUrl) {
			if (searchResultUrl.startsWith('/')) {
				searchResultUrl = searchResultUrl.substring(1, searchResultUrl.length);
			}
			let isDefaultPort = location.port == '' || location.port == '80' || location.port == '443'
			let port = isDefaultPort ? '' : `:${location.port}`;
			let retValue = `${location.protocol}//${location.host}${port}`;
			retValue += `/${PREFIX}${searchResultUrl}`;
			return retValue;
		},
		getLabel(result) {
			const {category} = result;

			if(category) {
				return category;
			} else {
				const {layout} = result;
				return this.labels[layout] || '';
			}
		},
		setSearchInAttachments(searchInAttachments) {
			this.searchInAttachments = searchInAttachments;
		},
		search(query, page = 0) {
			this.query = query;
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(SEARCH_URL, {
					params: {
						query: query.trim().toLowerCase() + ' | ' +  query.trim().toLowerCase() + '*',
						from: page * PAGE_SIZE,
						size: PAGE_SIZE,
						searchInAttachments: this.searchInAttachments,
						lang: window.lang
					}
				}).then((response) => {
					this.searchResults = response.data.hits;
					this.currentPage = Math.ceil(response.data.from / PAGE_SIZE);
					this.numberOfPages = Math.ceil(response.data.total / response.data.size);
					this.numberOfSearchResults = response.data.total;
					this.isLoading = false;
					this.searchedAtLeastOnce = true;
					this.hitsOnPage = response.data.size;
				}).catch((error) => {
					this.isLoading = false;
				});
			}
		},
		autoSuggest(query) {
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(SUGGEST_URL, {
					params: {
						query: query,
						searchInAttachments: this.searchInAttachments,
						lang: window.lang
					}
				}).then((response) => {
					this.suggestions = response.data.suggestions;
					this.isLoading = false;
				}).catch((error) => {
					this.isLoading = false;
				});
			} else {
				this.suggestions = [];
			}
		},
		clearSuggestion() {
			this.suggestion = '';
		},
		pageSelectLabel(page) {
			return `${page + 1} / ${this.numberOfPages}`;
		},
		changeToPage(page) {
			if (page >= 0 && page < this.numberOfPages + 1) {
				this.currentPage = page - 1;
				this.search(this.query, this.currentPage);
				VueScrollTo.scrollTo(this.selectorToScrollToOnPageChange, this.scrollDurationInMs, {offset: this.scrollOffsetInPx});
			}
		},
		...mapActions('headerSearchStore', ['toggleHeaderSearchMenu'])
	},
	watch: {
		numberOfPages(numberOfPages) {
			let pages = [];

			if (numberOfPages) {
				for (let i = 0; i < numberOfPages; i++) {
					pages.push(i);
				}
			}

			this.pages = pages;
		}
	},
	props: ['selectorToScrollToOnPageChange', 'scrollDurationInMs', 'scrollOffsetInPx'],
	mounted() {
		if (window.location.hash && new RegExp(QUERY_HASH).test(window.location.hash)) {
			this.query = decodeURI(window.location.hash.split('=')[1]);
		} else {
			this.isLoading = false;
		}
		this.toggleHeaderSearchMenu();
	}
}



// WEBPACK FOOTER //
// ../source/modules/SRC01-search/SRC01-search.js